<template>
    <page :back-to="getPreviousUrl" title="Scheduled notifications" size="is-widescreen">
        <div slot="page-header-right">
            <button class="button is-primary" @click="create">Add Message</button>
        </div>
        <div class="box">
            <div class="tabs">
              <ul>
                <li :class="{'is-active': tab == 'every_monday'}"><a @click="tab = 'every_monday'">Every monday</a></li>
                <li :class="{'is-active': tab == 'twice_monthly'}"><a @click="tab = 'twice_monthly'">Twice monthly</a></li>
                <li :class="{'is-active': tab == 'inactive_users'}"><a @click="tab = 'inactive_users'">Inactive users</a></li>
              </ul>
            </div>
            <b-table
                v-sortable="sortableOptions"
                :data="msg_list.data"
                :loading="msg_list.loading"
            >
                <template slot-scope="props">
                    <b-table-column custom-key="move" width="50">
                      <button class="button is-white drag-button" :msg-id="props.row.id">
                        <b-icon icon="cursor-move" size="is-small"></b-icon>
                      </button>
                    </b-table-column>
                    <b-table-column label="Send order" width="50" class="has-text-centered">{{ props.row.send_order }}</b-table-column>
                    <b-table-column label="Message" min-width="400">
                        <div style="clear: both; display: block; ">{{ props.row.message }}</div>
                    </b-table-column>
                    <b-table-column label="Last sent" width="100">
                        <div style="clear: both; display: block; " class="has-text-centered">{{ props.row.last_send_date }}</div>
                    </b-table-column>
                    <b-table-column label="Sent count" width="150">
                        <div style="clear: both; display: block; " class="has-text-centered">{{ props.row.send_count }}</div>
                    </b-table-column>
                    <b-table-column label="Action" width="100" custom-key="actions">
                        <div>
                        <button class="button" @click="deleteIt(props.row)">
                            Delete
                        </button>
                        </div>
                    </b-table-column>
                </template>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                        </p>
                        <p>No result.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </page>
</template>

<script>
import ScheduledNotificationAdd from "@/modules/admin/pages/pns/ScheduledNotificationAdd";

export default {
  data() {
    return {
      tab: 'every_monday',
      msg_list: new window.RemoteCollection(
        "/admin/api/notifications/scheduled"
      ),
      sortableOptions: {
        chosenClass: "is-selected",
        handle: ".drag-button",

        onChange: event => {
          this.newId = event.newIndex;
        },
        onUpdate: event => {
          let msgId = event.item
            .getElementsByClassName("drag-button")[0]
            .getAttribute("msg-id");

          let endpoint = `/admin/api/notifications/${msgId}`;

          this.$http.put(endpoint, {order: this.newId}).then(this.reordered);

        }
      },
      newId: null,
    };
  },

  created() {
    this.load();
  },

  computed: {
    filters() {
      return {
        send_frequence: this.tab,
      }
    },

    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },
  watch: {
    tab() {
      this.load();
    }
  },

  methods: {
    load() {
      this.msg_list.filter(this.filters, true).load();
    },

    create() {
      this.$buefy.modal.open({
        component: ScheduledNotificationAdd,
        props: {
          added: () => this.load(),
        },
      });
    },

    deleteIt(a_msg) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message: "Delete this message from the scheduled messages.",
        cancelText: "Cancel",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          new window.Form()
            .delete(`/admin/api/notifications/scheduled/${a_msg.id}`)
            .then(this.revoked);
        },
      });
    },

    reordered() {
      this.load();
    },

    revoked() {
      this.load();
      this.$buefy.toast.open("The message deleted");
    },
  }
};
</script>
